import * as React from "react";
import { IconButton } from "@mui/material";
import MovieFilterIcon from "@mui/icons-material/MovieFilter";
import { useNavigate } from "react-router";
import { routePaths } from "../../../../Router/router";

export interface PageHeadTimetoolProps {}

const PageHeadTimetool: React.FC<PageHeadTimetoolProps> = (props) => {
  const navigate = useNavigate();

  return (
    <IconButton color="ghost" size="small" onClick={() => navigate(`${routePaths.timetool.path}`)}>
      <MovieFilterIcon />
    </IconButton>
  );
};

export default PageHeadTimetool;
